import { useQuery } from 'react-query';
import api from 'services';

export const usePort = portId => useQuery(['port', portId], () => {
    api.getPort({ id: portId, history: true, all: true });
});



// WEBPACK FOOTER //
// ./app/components/Regions/PortManagement/hooks/ports/queries.js